import { useState } from 'react'
import { getStoredConsent, storeConsent, updateConsent, type ConsentChoice } from './consent'

/**
 * Lightweight cookie-consent banner (GDPR / Consent Mode v2). Shows once until
 * the visitor chooses. Rendered client-only via <ClientOnly> in RootLayout.
 */
export function ConsentBanner() {
  const [choice, setChoice] = useState<ConsentChoice | null>(() => getStoredConsent())

  if (choice) return null

  const decide = (granted: boolean) => {
    const next: ConsentChoice = granted ? 'accepted' : 'rejected'
    storeConsent(next)
    updateConsent(granted)
    setChoice(next)
  }

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-4 inset-x-4 md:left-auto md:right-6 md:max-w-md z-[100] bg-white border border-slate-200 rounded-2xl shadow-2xl p-5"
    >
      <p className="text-sm text-slate-600 font-light leading-relaxed">
        We use cookies to analyze traffic and improve your experience. You can accept all cookies or
        continue with only the essential ones.{' '}
        <a href="/privacy" className="text-rust hover:text-navy underline underline-offset-2">
          Privacy Policy
        </a>
      </p>
      <div className="mt-4 flex items-center justify-end gap-3">
        <button
          type="button"
          onClick={() => decide(false)}
          className="text-sm font-medium text-slate-500 hover:text-navy px-4 py-2 rounded-lg transition-colors"
        >
          Essential only
        </button>
        <button
          type="button"
          onClick={() => decide(true)}
          className="text-sm font-medium text-white bg-navy hover:bg-slate-800 px-5 py-2 rounded-lg shadow-sm transition-colors"
        >
          Accept all
        </button>
      </div>
    </div>
  )
}
